import { render, staticRenderFns } from "./ClinicPacks.vue?vue&type=template&id=f49081dc"
import script from "./ClinicPacks.vue?vue&type=script&lang=js"
export * from "./ClinicPacks.vue?vue&type=script&lang=js"
import style0 from "./ClinicPacks.vue?vue&type=style&index=0&id=f49081dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports